import React from 'react';
import { Box, Flex, Link } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';

import Text from './Text';
import TextAccordion from './TextAccordion';
import { highGasDelays, transferTimes } from '../lib/copy';

const Faqs = (props) => {
  return (
    <Box {...props}>
      <TextAccordion
        title={highGasDelays.title}
        content={highGasDelays.content}
      />
      <TextAccordion
        title={transferTimes.title}
        content={transferTimes.content}
      />
      <Flex>
        <Text textStyle="small" mt="8px" style={{ color: 'grey2', d: 'flex' }}>
          Have more questions?
        </Text>
        <Link ml="3px" isExternal href="https://support.palm.io/hc/en-us/sections/4406413295515-Bridge">
          <Text d="flex" alignItems="center" textStyle="small" mt="8px" style={{ color: 'grey2' }}>
            Check out our FAQ page
            <ExternalLinkIcon mx="3px" />
          </Text>
        </Link>
      </Flex>
    </Box>
  );
};

export default Faqs;
